/*
 * Free-samples substitution resolver (pure logic).
 *
 * Given the desired sample handles for a cart and an availability predicate,
 * returns the actual samples to give as [{ handle, quantity }], substituting any
 * out-of-stock sample with the first available handle in its fallback chain and
 * merging duplicates into quantities (the "double up"). Total unit count is
 * preserved as long as at least one sample in a chain is available.
 *
 * Loads in the browser as window.FreeSamplesResolver and under Node via require().
 * Keep the chains here in sync with the Liquid mirror in
 * snippets/free-samples-product-badge.liquid.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.FreeSamplesResolver = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Ordered fallback chains. The first AVAILABLE handle in the chain wins.
  // Same-family swap first (Light <-> Rich moisturizers), then Hyaluronic, then oil.
  var SAMPLE_SUBSTITUTIONS = {
    'sample-nexultra-p-light': [
      'sample-nexultra-p-rich-moisturizer-rich-texture-5ml-b2c',
      'sample-the-hyaluronic-serum-ha-booster-5ml',
      'sample-lhuile-universal-cleansing-olive-oil-5ml-free'
    ],
    'sample-nexultra-p-rich-moisturizer-rich-texture-5ml-b2c': [
      'sample-nexultra-p-light',
      'sample-the-hyaluronic-serum-ha-booster-5ml',
      'sample-lhuile-universal-cleansing-olive-oil-5ml-free'
    ],
    'sample-the-hyaluronic-serum-ha-booster-5ml': [
      'sample-nexultra-p-rich-moisturizer-rich-texture-5ml-b2c',
      'sample-nexultra-p-light',
      'sample-lhuile-universal-cleansing-olive-oil-5ml-free'
    ],
    'sample-lhuile-universal-cleansing-olive-oil-5ml-free': [
      'sample-the-hyaluronic-serum-ha-booster-5ml',
      'sample-nexultra-p-rich-moisturizer-rich-texture-5ml-b2c',
      'sample-nexultra-p-light'
    ]
  };

  // Freeze the shared chains so they can't be mutated at runtime.
  Object.keys(SAMPLE_SUBSTITUTIONS).forEach(function (key) {
    Object.freeze(SAMPLE_SUBSTITUTIONS[key]);
  });
  Object.freeze(SAMPLE_SUBSTITUTIONS);

  // Resolve a single desired handle to the handle the customer should receive.
  // Returns the original handle if available; otherwise the first available entry
  // in its fallback chain. A handle not present in SAMPLE_SUBSTITUTIONS has no
  // chain, so only the original handle itself is tried. Returns null if neither
  // the original nor any chain entry is available.
  function resolveOne(handle, isAvailable) {
    if (isAvailable(handle)) return handle;
    var chain = SAMPLE_SUBSTITUTIONS[handle] || [];
    for (var i = 0; i < chain.length; i++) {
      if (isAvailable(chain[i])) return chain[i];
    }
    return null;
  }

  // Resolve a set of desired handles into [{ handle, quantity }], preserving the
  // order of first appearance and merging duplicates into quantities.
  function resolveSamples(desiredHandles, isAvailable) {
    var order = [];
    var quantities = {};
    for (var i = 0; i < desiredHandles.length; i++) {
      var resolved = resolveOne(desiredHandles[i], isAvailable);
      if (resolved === null) continue;
      if (!Object.prototype.hasOwnProperty.call(quantities, resolved)) {
        quantities[resolved] = 0;
        order.push(resolved);
      }
      quantities[resolved] += 1;
    }
    return order.map(function (h) {
      return { handle: h, quantity: quantities[h] };
    });
  }

  return {
    SAMPLE_SUBSTITUTIONS: SAMPLE_SUBSTITUTIONS,
    resolveOne: resolveOne,
    resolveSamples: resolveSamples
  };
});
